import React from 'react'
import { Translation } from '@morningtrain/react-translations'
import ResourceSelector from '../simpletons/ResourceSelector'
import { StaticFilter } from '@morningtrain/react-filters'

export default function DepartmentsField ({ children, ...forwardProps }) {
  return (
    <ResourceSelector
      name='department_id'
      optionsKey='name'
      resourceName='departments'
      operationName='select'
      withSelectAll
      selectAllLabel={<Translation name='generic.select_all' />}
      label={<Translation name='fields.departments.label' />}
      {...forwardProps}
    >
      <StaticFilter name='in_production' true />
      {children}
    </ResourceSelector>
  )
}
